import React from 'react';
import Item from './Item';
export default class List extends React.Component {

	render () {
		const { courses, isMedieval } = this.props;

		return (
			<div id="courses-list" className="w-full">
				{courses.map((course, i) => <Item key={course.id} course={course} isMedieval={isMedieval} />)}
			</div>
		);
	}
}
